// @ts-nocheck
import React from "react";
import { TabsUsuarios } from "./Componentes/TabsUsuarios";
import { ProvideUsuarios } from "./State/ProvideUsuarios";
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import SinapThemev2 from '../styles/SinapThemev2';
import Keycloak from "../Auth/Keycloak";
import { FormularioAlta } from "./FormularioAlta";
import { ACCESO_USUARIOS, RUTA_API_USUARIOS } from "../Contantes/Constantes";
import { useBody } from "../Body/state/BodyContext";
import axios from "axios";
import { setupInterceptorsTo } from "../Componentes/API/AxiosBuilder";
import Error from "../Error/Error";
import { ErrorFormulario } from "./ErrorFormulario";
import { ProvideFormulario } from "./State/FormularioState/ProvideFormulario";

export const FormularioSolicitud = () => {
    const { setMessage } = useBody();
    const [error, setError] = React.useState(false);
    const searchParams = new URLSearchParams(document.location.search)

    React.useEffect(() => {
        axios({
            method: 'GET',
            url: RUTA_API_USUARIOS + '/solicitudes/registro/' + searchParams.get('uuid') + '/isvalid',
        }).then(response => {
        }).catch(() => {
            setError(true)
        })
    }, [])

    return (
        <ProvideUsuarios>
            {error ? <ErrorFormulario /> :
                (
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={SinapThemev2}>
                            <ProvideFormulario>
                                <FormularioAlta isSolicitud={true} tab={0} mostrarLegajoAlumno={false} mostrarContrasena={true} />
                            </ProvideFormulario>
                        </ThemeProvider>
                    </StyledEngineProvider>
                )}
        </ProvideUsuarios>
    );
}